<ndt-add-user-view
   [callState]="callState | async"
   [form]="form"
   [isSystemUser]="isSystemUser$ | async"
   [isAdminUser]="isAdminUser$ | async"
   [fromAccount]="fromAccount"
   [numberOfUsers]="numberOfUsers$ | async"
   (formCanceled)="onCloseClick()"
   (formSubmitted)="onCreate()"
>
</ndt-add-user-view>
